import * as types from './types';

const initialState = {
  swipeStatus: false,
};

const swipeToFullScreen = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_STATUS: {
      return {
        ...state,
        swipeStatus: action.value,
      };
    }
    default:
      return state;
  }
};
export default swipeToFullScreen;
